
/**
 * 트윗 유형
 */
export type TrendItemContentTweetsItemReferencedTweetTweetBasicInfoAllOfTwoTweetType = typeof TrendItemContentTweetsItemReferencedTweetTweetBasicInfoAllOfTwoTweetType[keyof typeof TrendItemContentTweetsItemReferencedTweetTweetBasicInfoAllOfTwoTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrendItemContentTweetsItemReferencedTweetTweetBasicInfoAllOfTwoTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
  RETWEET: 'RETWEET',
} as const;
